import { i18n } from '@/i18n'

function getGeneralFormat (value, locale = null, options = {}, format = null) {
  if (!locale) {
    locale = i18n.locale
  }

  const nf = new Intl.NumberFormat(locale, options)

  if (format === 'parts') {
    return nf.formatToParts(value)
  }

  return nf.format(value)
}

function getDecimalFormat (value, minDecimal = 0, maxDecimal = 2, locale = null, format = null) {
  const options = {
    style: 'decimal',
    minimumFractionDigits: minDecimal,
    maximumFractionDigits: maxDecimal
  }

  return getGeneralFormat(value, locale, options, format)
}

function getPercentFormat (value, minDecimal = 0, maxDecimal = 2, locale = null, format = null) {
  const options = {
    style: 'percent',
    minimumFractionDigits: minDecimal,
    maximumFractionDigits: maxDecimal
  }

  return getGeneralFormat(value / 100, locale, options, format)
}

function getCurrencyFormat (value, code = 'EUR', locale = null, format = null) {
  const options = {
    style: 'currency',
    currency: code
  }

  return getGeneralFormat(value, locale, options, format)
}

function getCurrencySymbolPosition (value, code = 'EUR', locale = null) {
  const currency = getCurrencyFormat(value, code, locale, 'parts')

  const symbolPosition = currency.findIndex(item => item.type === 'currency')
  const numberPosition = currency.findIndex(item => item.type === 'integer')

  return (symbolPosition > numberPosition) ? 'right' : 'left'
}

export { getDecimalFormat, getPercentFormat, getCurrencyFormat, getCurrencySymbolPosition }
